import { useNavigate } from "react-router-dom";

const SessionExpired = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center flex-col bg-gray-100">
      <h1 className="text-2xl font-semibold text-red-600 mb-4">Session Expired</h1>
      <p className="mb-6">Your session has expired. Please log in again.</p>
      <button
        onClick={() => navigate("/login")}
        className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
      >
        Login Now
      </button>
    </div>
  );
};

export default SessionExpired;
